export const enum RoleEnum {
  Staff = 1,
  Standard = 2,
  Admin = 3
}
